import { Component, Input, OnInit } from "@angular/core";
import { VidalyticsLoaderService } from "src/app/services/vidalytics.service";

@Component({
  selector: "video-player-vidalytics",
  templateUrl: "video-player-vidalytics.html",
  styleUrls: ["video-player-vidalytics.scss"],
})
export class VideoPlayerVidalyticsComponent implements OnInit {
  @Input() vidalyticsEmbedId: string = "";
  @Input() mobileTiming: number = 0;
  @Input() desktopTiming: number = 0;
  videoClass = "vidalytics";

  constructor(public vidalyticsLoaderService: VidalyticsLoaderService) {}

  async ngOnInit() {
    this.setVidalytics();
  }

  // Load vidalytics
  setVidalytics() {
    this.vidalyticsLoaderService.loadVidalytics({
      vidalyticsEmbedId: this.vidalyticsEmbedId,
      buttonId: "button",
      mobileTiming: this.mobileTiming || 0,
      desktopTiming: this.desktopTiming || 0,
      showClass: "video__nextPageShown",
      hideClass: "video__nextPageHidden",
    });
  }
}
